import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssociationFragmentFragment = { __typename?: 'Association', id: string, imageSrc?: string | null, associationURL?: string | null, isStufenvereinigung: boolean, name: { __typename?: 'TranslationObject', de: string, fr: string, it: string }, short: { __typename?: 'TranslationObject', de: string, fr: string, it: string }, billingInformation?: { __typename?: 'BillingInformation', canton?: string | null } | null };

export type GetAssociationsForFrontendQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAssociationsForFrontendQuery = { __typename?: 'Query', getAssociationsForFrontend: Array<{ __typename?: 'AssociationWithPresident', association: { __typename?: 'Association', id: string, imageSrc?: string | null, associationURL?: string | null, isStufenvereinigung: boolean, name: { __typename?: 'TranslationObject', de: string, fr: string, it: string }, short: { __typename?: 'TranslationObject', de: string, fr: string, it: string }, billingInformation?: { __typename?: 'BillingInformation', canton?: string | null } | null }, presidents?: Array<{ __typename?: 'President', name: string, email: string }> | null }> };

export const AssociationFragmentFragmentDoc = gql`
    fragment AssociationFragment on Association {
  id
  name {
    de
    fr
    it
  }
  short {
    de
    fr
    it
  }
  imageSrc
  associationURL
  billingInformation {
    canton
  }
  isStufenvereinigung
}
    `;
export const GetAssociationsForFrontendDocument = gql`
    query getAssociationsForFrontend {
  getAssociationsForFrontend {
    association {
      ...AssociationFragment
    }
    presidents {
      name
      email
    }
  }
}
    ${AssociationFragmentFragmentDoc}`;

/**
 * __useGetAssociationsForFrontendQuery__
 *
 * To run a query within a React component, call `useGetAssociationsForFrontendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssociationsForFrontendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssociationsForFrontendQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssociationsForFrontendQuery(baseOptions?: Apollo.QueryHookOptions<GetAssociationsForFrontendQuery, GetAssociationsForFrontendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssociationsForFrontendQuery, GetAssociationsForFrontendQueryVariables>(GetAssociationsForFrontendDocument, options);
      }
export function useGetAssociationsForFrontendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssociationsForFrontendQuery, GetAssociationsForFrontendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssociationsForFrontendQuery, GetAssociationsForFrontendQueryVariables>(GetAssociationsForFrontendDocument, options);
        }
export type GetAssociationsForFrontendQueryHookResult = ReturnType<typeof useGetAssociationsForFrontendQuery>;
export type GetAssociationsForFrontendLazyQueryHookResult = ReturnType<typeof useGetAssociationsForFrontendLazyQuery>;
export type GetAssociationsForFrontendQueryResult = Apollo.QueryResult<GetAssociationsForFrontendQuery, GetAssociationsForFrontendQueryVariables>;